( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-copy-swiper').each(function () {
			const sliderEl = $(this)[0];
			const navParent = $('.js-case-studies-carousel-nav', sliderEl);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				autoHeight: true,
				slidesPerView: 1,
				effect: 'fade',

				pagination: {
					el: $('.js-carousel-nav-pagination', sliderEl)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', sliderEl)[0],
					prevEl: $('.js-carousel-nav-prev', sliderEl)[0],
				},
			});
		});
	} );
} )( jQuery, document, window );
